module.exports = __webpack_public_path__ + "img/120h100_obe_poloviny_povorotno_otkidnye.94b2af44.svg";